// Generated by Melange

import * as Buhta_cabinet__BatchSignLayout from "./BatchSignLayout.js";
import * as Buhta_cabinet__DocumentEdo from "../../../grpc/DocumentEdo.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (id) {
    const func = Buhta_cabinet__DocumentEdo.DocumentBatchService.view;
    const match = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._3(func, param, {
                        hd: "owner_stats",
                        tl: /* [] */0
                      }, id);
          }), undefined);
    const dispatchModel = match[1];
    const batch = match[0];
    React.useEffect((function () {
            Curry._2(dispatchModel, undefined, undefined);
          }), [id]);
    if (typeof batch === "string" || batch.NAME !== "Data") {
      return null;
    } else {
      return JsxRuntime.jsx(Buhta_cabinet__BatchSignLayout.make, {
                  org: org,
                  id: id,
                  batch: batch.VAL
                });
    }
  };
}

function BatchSignPage(Props) {
  return make(Props.org)(Props.id);
}

const make$1 = BatchSignPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__BatchSignLayout Not a pure module */
